export const COOKIE_POLICY_LINK = 'https://www.wix.com/about/cookie-policy'

export const GLOBAL_POLICY_CONTROL_SPEC =
  'specs.cookieConsent.PolicyByGlobalPrivacyControl'
